export default __webpack_public_path__ + "static/media/MaloteSelected.50d09751.svg";